/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
import Fuse from 'fuse.js';
import { orderBy } from 'lodash';

import { InitialState, actionTypes } from './createTeamContext';

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_IS_LOADING:
      state.isLoading = action.isLoading;

      break;

    case actionTypes.SET_USER_LISTS:
      state.baseUserList = action.baseUserList;
      state.userList = action.userList;

      break;

    case actionTypes.SET_USER_CHECKED_STATE:
      // eslint-disable-next-line no-case-declarations
      const userIndex = state.selectedUserList.findIndex((e) => {
        return e.email === action.email;
      });

      if (userIndex === -1) {
        const user = state.baseUserList.find((e) => {
          return e.email === action.email;
        });

        state.selectedUserList = [...state.selectedUserList, user];
      } else {
        state.selectedUserList = state.selectedUserList.filter((u) => {
          return u.email !== action.email;
        });
      }

      break;

    case actionTypes.FILTER_USER_LIST_BY_SEARCH:
      state.userList = orderBy(state.baseUserList, ['firstName'], ['asc']);

      if (!action.searchString || action.searchString.length === 0) {
        break;
      }

      // eslint-disable-next-line no-case-declarations
      const fuse = new Fuse(state.userList, {
        shouldSort: false,
        threshold: 0.25,
        keys: ['firstName', 'lastName', 'email'],
      });

      state.userList = fuse.search(action.searchString);

      break;

    case actionTypes.SET_EDIT_TEAM_CHECKED_USERS:
      state.userList.forEach((user) => {
        if (action.assignedProfiles?.indexOf(user.profileId) !== -1) {
          state.selectedUserList.push(user);
        }
      });

      break;

    case actionTypes.SET_SENDING: {
      state.sending = action.payload;

      break;
    }

    case actionTypes.SET_USERS_FEATURES: {
      state.userProductFeaturesMap = action.userProductFeaturesMap;

      break;
    }

    case actionTypes.SET_TEAM_INFO: {
      state.teamInfo = { ...state.teamInfo, ...action.payload };

      break;
    }

    case actionTypes.SET_NO_LICENSE_MODAL: {
      state.noLicenseModal = action.payload;

      break;
    }

    case actionTypes.SET_ASSIGN_LICENSE_MODAL: {
      state.assignLicenseModal = action.payload;

      break;
    }

    case actionTypes.SET_MULTI_NO_LICENSE_MODAL: {
      state.multiLicenseModal = action.payload;

      break;
    }

    case actionTypes.SET_ASSIGN_LICENSE_BODY: {
      state.assignLicenseBody = action.payload;

      break;
    }

    default:
      return InitialState;
  }
};
